import { createOnClientEntry, createOnPreRouteUpdate, wrapRootElement } from './src/shared/gatsby/browser-utils';
import { wrapPageElement } from './src/shared/utils/useStaticQueryError/wrapPageElement';
import { getPageType, microPrefix } from './src/utils/pageType';

export { wrapRootElement, wrapPageElement };

export const onClientEntry = createOnClientEntry();
export const onPreRouteUpdate = createOnPreRouteUpdate(getPageType, microPrefix);
